import { Component, OnInit } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { TranslateService } from "@ngx-translate/core";
import { FaqDialogComponent } from "src/app/dashboard/faq-dialog/faq-dialog.component";
import { GuidesDialogComponent } from "src/app/dashboard/guides-dialog/guides-dialog.component";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
	selector: "app-menu",
	templateUrl: "./menu.component.html",
	styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
	partnerCode: string = "carsomeCapital";

	showFAQ: Boolean = false;
	showFAQList: string[] = ["cbp"];

	constructor(
		private dialog: MatDialog,
		public translate: TranslateService,
		private partnerService: PartnerService,
	) {}

	ngOnInit(): void {
		this.getPartnerCode();
	}

	private getPartnerCode() {
		this.partnerCode = this.partnerService.getPartnerCode();
		!this.partnerCode ? (this.partnerCode = "carsomeCapital") : null;
		if (this.showFAQList.includes(this.partnerCode)) {
			this.showFAQ = true;
		}
	}

	guideDialog() {
		this.dialog.open(GuidesDialogComponent, {
			panelClass: "guide-dialog",
		});
	}

	switch(lang: string) {
		this.translate.use(lang);
	}

	faqDialog() {
		this.dialog.open(FaqDialogComponent, {
			panelClass: "faq-dialog",
		});
	}
}
